import React, {Fragment, useState} from 'react';
import {Translate} from "../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {Modal} from "react-bootstrap";
import Button from "../../common/Button";
import EditBulkItemsForm from "./forms/bulk-item/EditBulkItemsForm";

const EditBulkItemsModal = ({items}) => {

    const t = Translate;
    const lang = useSelector(selectLang);
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);


    return (
        <Fragment>
            <span onClick={handleShow}>{t(lang, "items.common.bulk_edit")}</span>
            {show &&
                <Modal show={true}
                       onHide={handleClose}
                       fullscreen
                       className="p-0"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t(lang, "items.common.bulk_edit")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Modal.Body style={{position: 'initial'}}>
                            <EditBulkItemsForm editingItems={items}
                                               handleClose={handleClose}
                            />
                        </Modal.Body>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary"
                                onClick={handleClose}
                                size="lg"
                        >
                            {t(lang, "items.common.cancel")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </Fragment>
    );
};

export default EditBulkItemsModal;
